// 表格列宽度
// 在页面中使用 TABLE_COLUMN_WIDTH['WORD2']
export const TABLE_COLUMN_WIDTH = {
    WORD2: 58,
    WORD3: 72,
    WORD4: 86,
    WORD5: 100,
    WORD6: 114,
    WORD7: 128,
    WORD8: 142,
    WORD9: 156,
    WORD10: 170,
    WORD11: 184,
    WORD12: 198,
    WORD40: 588,
    MOBILE: 120,
    DATE: 130,
    SHORT_DATE_TIME: 154,
    DATE_TIME: 180,
    INDEX: 65
};

/* 表单项label宽度
    在页面中使用 FORM_LABEL_WIDTH['WORD2']
    必填项*星号算作一个汉字，要做长度计算
    label通常单行不超过5个字，超出可换行
 */
export const FORM_LABEL_WIDTH = {
    WORD2: 34,
    WORD3: 48,
    WORD4: 62,
    WORD5: 76,
    WORD6: 90,
    WORD7: 104,
    WORD8: 118,
    WORD9: 132,
    WORD10: 146,
    WORD11: 160,
    WORD12: 174
};

// 详情项label宽度
// 在页面中使用 INFO_LABEL_WIDTH['WORD2']
export const INFO_LABEL_WIDTH = {
    WORD2: 42,
    WORD3: 56,
    WORD4: 70,
    WORD5: 84,
    WORD6: 98,
    WORD7: 112,
    WORD8: 126,
    WORD9: 140,
    WORD10: 154,
    WORD11: 168,
    WORD12: 182
};
